import { ApiType } from "@gymflow/common";
import {
  AppointmentPurchaseSummaryDTO,
  AppointmentPurchaseSummaryPostDTO,
} from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { appointmentQueryKeys } from "./appointmentQueryKeys";

export async function appointmentSummaryQueryFn({
  api,
  filter,
}: {
  api: ApiType;
  filter: AppointmentPurchaseSummaryPostDTO;
}) {
  const result = await api.appointmentApi.summary(filter);
  return result.data;
}

export function useAppointmentSummary(
  {
    api,
    opts,
  }: {
    api: ApiType;
    opts: AppointmentPurchaseSummaryPostDTO;
  },
  queryOpts?: Omit<
    UseQueryOptions<unknown, unknown, AppointmentPurchaseSummaryDTO>,
    "queryKey"
  >,
) {
  const result = useQuery({
    queryKey: appointmentQueryKeys.summary(opts),
    queryFn: () => appointmentSummaryQueryFn({ api, filter: opts }),
    ...queryOpts,
  });
  return result;
}
